import { Box, TextButton } from '@zillow/constellation-10';
import { useContext } from 'react';
import { AppContext } from '../../contexts/AppContextProvider';

export default function ViewLeads(): JSX.Element {
  const { paths } = useContext(AppContext);

  return (
    <Box css={{ borderBottom: '1px solid', borderBottomColor: 'border.muted', padding: 'loose' }}>
      <TextButton asChild textStyle="body-sm-bold">
        <a href={paths.leadsPage}>View contacts</a>
      </TextButton>
    </Box>
  );
}
